import React from 'react';

function AdminPanel() {
  return (
    <div className="admin-panel">
      <h2>Admin Panel</h2>
      <p>Manage users, challenges, and settings here.</p>
    </div>
  );
}

export default AdminPanel;